module.exports = __webpack_public_path__ + "static/media/screenverse.2111667e.png";